import React, {useContext,useState} from 'react';
import {MyContext} from '../../login/MyContext';

import Count from '../principal/Count';

function Principal () {

    const {user} = useContext(MyContext); 

    
    const {toggleNav,registerUser} = useContext(MyContext);
    const initialState = {
        userInfo:{
            name:'',
            documento:'',
            ciudad:'',
            licencia:'',
            email:'',
            clave:'',
            pass:'',
            tipo_usuario:'empresa',   
            hoy:'', 
            t_persona:'',
            tdoc:'',
            domicilio:'',
            nombre_r_legal:'',
            cedula_r_legal:'',
            contacto_empresarial:'',
            telefono_contacto:''    
        },
        errorMsg:'',
        successMsg:'',
    }
    const [state,setState] = useState(initialState);

    // On Submit the Registration Form
    const submitForm = async (event) => {
      event.preventDefault();
      const data = await registerUser(state.userInfo);
      if(data.success){
          setState({
              ...initialState,
              successMsg:data.message,
          });
      }
      else{
          setState({
              ...state,
              successMsg:'',
              errorMsg:data.message
          });
      }
  }

  // On change the Input Value (name, email, password)
  const onChangeValue = (e) => {
      setState({
          ...state,
          userInfo:{
              ...state.userInfo,
              [e.target.name]:e.target.value
          }
      });
  }
  
  // Show Message on Success or Error
  let successMsg = '';
  let errorMsg = '';
  if(state.errorMsg){
      errorMsg = <div className="error-msg">{state.errorMsg}</div>;
  }
  if(state.successMsg){
      successMsg = <div className="success-msg">{state.successMsg}</div>;
  }

  
    
  if(user)
  {
  return (
 
<div id="content" class="app-content">

<ol class="breadcrumb float-xl-end">


</ol>






<Count/>



</div>
   
  )
  }
  else if(!user){
    return"";
}
}




export default Principal
